// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

:host h1,
:host h2,
:host h3,
:host p,
:host ul {
  margin: 0;
}

:host h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
}

:host h2 {
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

:host p,
:host ul {
  font-size: 18px;
  line-height: 1.18;
}

:host a {
  color: inherit;
}

:host .hero--inner {
  min-height: 200px;
  position: relative;
  padding-right: 0;
}

:host .hero--inner .hero__content,
:host .hero--inner .content {
  max-width: 620px;
  padding: 70px 0 20px 60px;
}

:host .hero--inner h1 {
  font-size: 36px;
  line-height: 1.12;
}

:host .hero--inner .hero__image,
:host .hero--inner > img {
  position: absolute;
  z-index: 1;
  right: 84px;
  top: 50%;
  width: 494px;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: right top;
  pointer-events: none;
}

:host .contact-content {
  width: 100%;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 60px var(--space-page-x) 150px;
}

:host .contact-content__item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

:host .contact-content__item a {
  color: var(--color-black);
  text-decoration: none;
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: "lnum" 1, "tnum" 1;
}

:host .cta {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 38px;
  padding: 30px 20px 40px;
  text-align: center;
  background: var(--color-green);
}

:host .cta__title {
  color: var(--color-white);
  font-size: 30px;
  line-height: 1.2;
  font-weight: 800;
}

:host .cta .secondary-button,
:host .cta .secondary-button:hover,
:host .cta .secondary-button:focus-visible {
  text-decoration: none;
}

@media (max-width: 1024px) {
  :host h1 {
    font-size: 48px;
    line-height: 1.12;
  }
}

@media (max-width: 767px) {
  :host h1 {
    font-size: 38px;
  }

  :host h2,
  :host .cta__title {
    font-size: 26px;
  }

  :host p,
  :host ul {
    font-size: 16px;
    line-height: 1.35;
  }

  :host .hero--inner .hero__content,
  :host .hero--inner .content,
  :host .study .hero--inner .hero__content,
  :host .study .hero--inner .content {
    padding: 40px 20px;
  }

  :host .hero--inner .hero__image,
  :host .hero--inner > img {
    right: -40px;
    width: 70%;
  }

  :host .contact-content {
    padding-inline: var(--space-page-x);
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/lsr_contact/lsr_contact.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,mCAAmC;EACrC;AACF","sourcesContent":[":host {\r\n  display: block;\r\n}\r\n\r\n:host h1,\r\n:host h2,\r\n:host h3,\r\n:host p,\r\n:host ul {\r\n  margin: 0;\r\n}\r\n\r\n:host h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n}\r\n\r\n:host h2 {\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n:host p,\r\n:host ul {\r\n  font-size: 18px;\r\n  line-height: 1.18;\r\n}\r\n\r\n:host a {\r\n  color: inherit;\r\n}\r\n\r\n:host .hero--inner {\r\n  min-height: 200px;\r\n  position: relative;\r\n  padding-right: 0;\r\n}\r\n\r\n:host .hero--inner .hero__content,\r\n:host .hero--inner .content {\r\n  max-width: 620px;\r\n  padding: 70px 0 20px 60px;\r\n}\r\n\r\n:host .hero--inner h1 {\r\n  font-size: 36px;\r\n  line-height: 1.12;\r\n}\r\n\r\n:host .hero--inner .hero__image,\r\n:host .hero--inner > img {\r\n  position: absolute;\r\n  z-index: 1;\r\n  right: 84px;\r\n  top: 50%;\r\n  width: 494px;\r\n  height: 100%;\r\n  max-width: none;\r\n  object-fit: cover;\r\n  object-position: right top;\r\n  pointer-events: none;\r\n}\r\n\r\n:host .contact-content {\r\n  width: 100%;\r\n  min-height: 360px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n  padding: 60px var(--space-page-x) 150px;\r\n}\r\n\r\n:host .contact-content__item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n:host .contact-content__item a {\r\n  color: var(--color-black);\r\n  text-decoration: none;\r\n  font-variant-numeric: lining-nums tabular-nums;\r\n  font-feature-settings: \"lnum\" 1, \"tnum\" 1;\r\n}\r\n\r\n:host .cta {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 38px;\r\n  padding: 30px 20px 40px;\r\n  text-align: center;\r\n  background: var(--color-green);\r\n}\r\n\r\n:host .cta__title {\r\n  color: var(--color-white);\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 800;\r\n}\r\n\r\n:host .cta .secondary-button,\r\n:host .cta .secondary-button:hover,\r\n:host .cta .secondary-button:focus-visible {\r\n  text-decoration: none;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  :host h1 {\r\n    font-size: 48px;\r\n    line-height: 1.12;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  :host h1 {\r\n    font-size: 38px;\r\n  }\r\n\r\n  :host h2,\r\n  :host .cta__title {\r\n    font-size: 26px;\r\n  }\r\n\r\n  :host p,\r\n  :host ul {\r\n    font-size: 16px;\r\n    line-height: 1.35;\r\n  }\r\n\r\n  :host .hero--inner .hero__content,\r\n  :host .hero--inner .content,\r\n  :host .study .hero--inner .hero__content,\r\n  :host .study .hero--inner .content {\r\n    padding: 40px 20px;\r\n  }\r\n\r\n  :host .hero--inner .hero__image,\r\n  :host .hero--inner > img {\r\n    right: -40px;\r\n    width: 70%;\r\n  }\r\n\r\n  :host .contact-content {\r\n    padding-inline: var(--space-page-x);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
